import { TranslationMap } from '@trimble-gcs/i18n-types';

export function scandataTreeTranslations() {
  return {
    station: {
      loading: {
        text: $localize`:@@scandataTree.station.loading:Loading...`,
        desc: 'Message displayed while stations are loading for a point cloud in the Scandata Tree.',
      },
      notLoaded: {
        text: $localize`:@@scandataTree.station.notLoaded:Only showing the first {limit} stations.`,
        desc: 'Message displayed when the point cloud has more stations than has been loaded and can be displayed in the Scandata Tree.',
      },
      viewInNumark: {
        text: $localize`:@@scandataTree.station.viewInNumark:View in Multi-pane`,
        desc:
          'Label for the button to view the point cloud in Numark. ' +
          "The term 'Multi-pane' is a brand name and not translated.",
      },
      displayName: {
        text: $localize`:@@scandataTree.station.displayName:Station: {stationName}`,
        desc: 'Display Name for the station entry in the Scandata Tree.',
      },
      tooltip: {
        text: $localize`:@@scandataTree.station.tooltip:Station: {stationName}`,
        desc: 'Tooltip for the station entry in the Scandata Tree.',
      },
      loadError: {
        text: $localize`:@@scandataTree.station.loadError:Failed to load`,
        desc: 'Error message displayed when a station fails to load in the Scandata Tree.',
      },
      disabled: {
        text: $localize`:@@scandataTree.station.disabled:Station view disabled in orthogonal mode.`,
        desc:
          'This message is displayed if the station view icon is disabled ' +
          'because the camera is set in orthographic mode.',
        limit: 50,
      },
    },
    scanInfoMessage: {
      notReady: {
        text: $localize`:@@scandataTree.scanInfoMessage.notReady:Not ready for viewing`,
        desc: 'Message displayed when a scan is not ready for viewing in the viewer.',
      },
      failedToIngest: {
        text: $localize`:@@scandataTree.scanInfoMessage.failedToIngest:Failed to ingest`,
        desc: 'Message displayed when a scan has failed to ingest and cannot be viewed in the viewer.',
      },
      failedToLoad: {
        text: $localize`:@@scandataTree.scanInfoMessage.failedToLoad:Failed to load`,
        desc: 'Message displayed when a scan has failed to load in the viewer.',
      },
      stationsOnly: {
        text: $localize`:@@scandataTree.scanInfoMessage.stationsOnly:Stations only`,
        desc: 'Message displayed when a scan has only stations and no pointcloud points.',
      },
      saveError: {
        text: $localize`:@@scandataTree.scanInfoMessage.saveError:Failed to save`,
        desc: 'Message displayed when a scan has failed to save in the viewer.',
      },
    },
  } satisfies TranslationMap;
}
